import React, { useState } from "react";
import UnlockEarlyIntroduction from "./UnlockEarlyIntroduction";
import UnlockEarlyValidation from "./UnlockEarlyValidation";

function DrawerUnlockEarlyTunnel () {
  const [unlockEarlyStep, setUnlockEarlyStep] = useState("introduction");

  if (unlockEarlyStep === "introduction") {
    return (
      <UnlockEarlyIntroduction
        goToUnlockEarlyValidationStep={() => setUnlockEarlyStep("validation")}
      />
    );
  }

  return (
    <UnlockEarlyValidation />
  )
}

export default DrawerUnlockEarlyTunnel;
